import { render } from "./WCWebAd.vue?vue&type=template&id=05b15cd0&scoped=true&ts=true"
import script from "./WCWebAd.vue?vue&type=script&lang=ts"
export * from "./WCWebAd.vue?vue&type=script&lang=ts"

import "./WCWebAd.vue?vue&type=style&index=0&id=05b15cd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b15cd0"]])

export default __exports__